import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  NgZone
} from '@angular/core';
import { MainPageService } from './../../../main-page.service';
import { ShowViewerArgs } from '../../../../models/viewer/ShowViewerArgs.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PipeRingModel } from '../../../../models/parts/pipering.model.';
import { PiperingGroupModel } from '../../../../models/dictionaries/pipering-group.model';
import { CorosiveProtectionModel } from '../../../../models/dictionaries/corosive-protection.model';
import { PipeRingVariantModel } from '../../../../models/parts/pipering-variant.model';
import { DesignBaseModel } from '../../../../models/dictionaries/design-base.model';


@Component({
  selector: 'app-pipe-rings-managment',
  template: `<div *ngIf="pipeRingData !== undefined">
    <div class="row" style="padding-left: 12px;">
        <b>Pipe-Ring:</b> &nbsp;{{pipeRingData.name}}</div>
    <div class="row" style="margin: 10px;">
        <!-- <button class="gray-button" (click)="openGraphicalTool()" [disabled]="!canOpenGraphicalTool">Open graphical tool</button> -->
        <button class="gray-button" data-toggle="modal" data-target="#editModal">Edit</button>
        <!-- <button class="gray-button" >Drawing/Pictures</button> -->
        <button class="gray-button" data-toggle="modal" data-target="#uploadModal">Upload file</button>
        <button class="gray-button" data-toggle="modal" data-target="#deleteModal">Delete</button>
    </div>
    <div class="row">
        <div class="col-6" style="line-height: 30px;">
            <div class="d-inline">Name:
            </div>
            <div class="d-inline">{{pipeRingData.name}}
                <br>
            </div>
            <div class="d-inline">Article no.:
            </div>
            <div class="d-inline">{{pipeRingData.articleId}}
                <br>
            </div>
            <div class="d-inline">Pipe-Ring group:
            </div>
            <div class="d-inline">{{piperingGroupsData[pipeRingData.piperingGroupId].name}}
                <br>
            </div>
            <div class="d-inline">Corrosion Protection:
            </div>
            <div class="d-inline">{{corrosionProtectionData[pipeRingData.corrosionProtectionId - 1].name}}
                <br>
            </div>
            <div class="d-inline">Graphical representation:
            </div>
            <div class="d-inline">{{pipeRingData.graphicalRepresentation | translate}}
                <br>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div id="regularPictureDiv" [hidden]="!isPngVisible">
                    <div class="row">
                        <img height=150 width=150 [src]="pictureData" id="regularPicture">
                    </div>
                    <div class="row">
                        <label style="font-size:12px">Main picture</label>
                        <button style="font-size:12px;height:23px;margin-left: 3px;" (click)="deletePicture()">x</button>
                    </div>
                </div>

                <div id="stpFileDiv" [hidden]="!isStpVisible">
                    <div class="step-file">STEP FILE</div>
                    <div class="row">
                        <img height=150 width=150 src="https://www.freeviewer.org/img/stp/overview-stp.png" id="stpPicture">
                    </div>
                    <div class="row" style="margin-top: 10px; margin-left: 10px;">
                        <button class="configure-button" style="font-size:12px;height:23px;margin-left: 3px;"  (click)="openGraphicalTool()" [disabled]="!canOpenGraphicalTool">
                            Configure
                        </button>
                        <button class="delete-button" style="font-size:12px;height:23px;margin-left: 3px;" (click)="deleteStepFile()">x</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="variants-header">
        <span style="padding-left: 18px; font-weight: bold; align-self: flex-end; padding-bottom: 3px;">Variants:</span>
        <button class="red-button" data-toggle="modal" data-target="#createVariantModal" (click)="prepareVariantCreate()"> Create new variant</button>
    </div>
    <div *ngIf="variantsList.length > 0" class="regularObjectBorder" id="variantsGrid">
        <div class="row">
            <div class="regularObjectBorder justRightBorder borderGray" *ngFor="let variant of variantsList;let i=index">
                <button [class.highlighted]="variant._id === currentVariantTabId" class="variantBtn" (click)="changeVariantTab(variant._id)">{{variant.name}}</button>
            </div>
        </div>
        <div class="row" style="padding: 18px 6px;">
            <button data-toggle="modal" data-target="#editVariantModal" class="gray-button" (click)="prepareVariantEdit()">Edit</button>
            <button data-toggle="modal" data-target="#duplicateVariantModal" class="gray-button">Duplicate</button>
            <button data-toggle="modal" data-target="#deleteVariantModal" class="gray-button">Delete</button>
            <button class="gray-button">Utilization check</button>
            <button class="gray-button" (click)="openVariantGraphicalTool(variantsList[currentVariantTab]._id)">Configure</button>
        </div>
        <div id="tabContent" class="regularObjectBorder justTopBorder">
            <div class="row" style="margin-top: 18px;">
                <div class="col-6">
                    <div class="font-weight-bold table-label">Name:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">{{variantsList[currentVariantTab].name}}</div>
                    <div class="extra-padding-top font-weight-bold table-label">Description:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">{{variantsList[currentVariantTab].description}}
                        <br>
                    </div>
                    <div class="extra-padding-top font-weight-bold table-label">Design base:
                        <br>
                    </div>
                    <div>
                        <select class="tableCurrentVariant" [(ngModel)]="choosenDesignBase">
                            <option *ngFor="let designBase of designBasesArray" [(value)]="designBase._id">{{designBase.name}}</option>
                        </select>
                        <br>
                    </div>
                </div>
                <div class="col-6">
                    <!-- <div class="font-weight-bold table-label">System:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">{{variantsList[currentVariantTab].system}}
                        <br>
                    </div>
                    <div class="extra-padding-top font-weight-bold table-label">Corrosion protection:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">{{variantsList[currentVariantTab].corrosionProtection}}
                        <br>
                    </div> -->
                    <div class="extra-padding-top font-weight-bold table-label">Files:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">&nbsp;</div>
                </div>

            </div>
            <div class="row">
                <br>
                <app-variant-verification-grid [DesignBaseId]="choosenDesignBase" [VariantId]="variantsList[currentVariantTab]._id"></app-variant-verification-grid>
            </div>
        </div>
    </div>
    <div class="col-6" *ngIf="variantsList.length == 0">
        <span>No variants available</span>
    </div>
</div>

<!-- Create Variant Modal -->
<div class="modal" id="createVariantModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="variantFormGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPipeRingVariant.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="editedPipeRingVariant.description" formControlName="description">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="variantFormGroup.invalid" (click)="saveNewVariant()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Upload Modal -->
<div class="modal" id="uploadModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div>
                    Select file:
                    <br/>
                    <input #fileUploadInput type="file" accept=".jpg,.jpeg,.png,.step,.stp">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger save-button" data-dismiss="modal" (click)="upload()">Upload</button>
            </div>

        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPipeRing.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Article no.:</span>
                                    <input type="number" [(ngModel)]="editedPipeRing.articleId" formControlName="articleId">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Pipe-Ring group:</span>
                                    <select name="piperingGroupSelect" class="selectHeight" [(ngModel)]="editedPipeRing.piperingGroupId" formControlName="piperingGroupId">
                                        <option *ngFor="let piperingGroup of piperingGroupsData" [ngValue]="piperingGroup.id">{{piperingGroup.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Corrosion protection:</span>
                                    <select name="corrosionProtectionSelect" class="selectHeight" [(ngModel)]="editedPipeRing.corrosionProtectionId" formControlName="corrosionProtectionId">
                                        <option *ngFor="let corrosionProtection of corrosionProtectionData" [ngValue]="corrosionProtection.id">{{corrosionProtection.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Pipe ring family:</span>
                                    <select name="corrosionProtectionSelect" class="selectHeight" [(ngModel)]="editedPipeRing.piperingFamilyId" formControlName="piperingFamilyId">
                                        <option *ngFor="let piperingFamily of piperingFamiliesArray" [ngValue]="piperingFamily.id">{{piperingFamily.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="save()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this pipe-ring?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePipeRing()">Delete</button>
            </div>
        </div>
    </div>
</div>

<!-- Duplicate Variant Modal -->
<div class="modal" id="duplicateVariantModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <div>Duplicate variant</div>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">New variant name:</span>
                    <input type="text" [(ngModel)]="editedPipeRingVariant.name">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="editedPipeRingVariant.name.length<3"
                    (click)="duplicateVariant()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Variant Modal -->
<div class="modal" id="deleteVariantModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <div>Delete variant</div>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span>Are you sure, you want to delete this variant?</span>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" (click)="deleteVariant()">Delete</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Variant Modal -->
<div class="modal" id="editVariantModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="editedPipeRingVariant.name">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="editedPipeRingVariant.description">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="editedPipeRingVariant.name.length<3"
                    (click)="updateVariant()">Save</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px;border-color:#dddd}.modal-label{width:168px}.display-flex{display:flex;align-items:center;margin-bottom:10px}hr{margin-top:0}#variantsGrid{margin-left:17px;border-color:#dddd}.delete-button{height:23px;width:23px;margin-left:3px;background-color:#d0021b;color:#fff;font-size:12px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;border-radius:2px;cursor:pointer}.configure-button{height:23px;margin-left:3px;background-color:#4a8bb7;color:#fff;font-size:12px;padding:3px 14px;font-weight:300;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;margin-bottom:6px;border-radius:2px;cursor:pointer}.configure-button:disabled{background-color:#999;cursor:default}.step-file{font-size:14px;text-align:center;margin-bottom:10px;font-weight:700}#stpFileDiv{margin-left:auto;margin-right:auto}#variantsTabGrid{border:0;margin-top:26px;border-top:1px solid #ddd}.extra-padding-top{padding-top:10px}.mat-header-cell{font-weight:700}.variantBtn{background-color:#ddd;border:none;padding:6px 18px;outline:0;color:#534f53;cursor:pointer}.variants-header{margin:28px 0 5px;display:flex;justify-content:space-between}.table-label{font-size:16px}.tableCurrentVariant{font-size:14px;border-color:#708090}.borderGray{border-color:#a9a9a9}.borderGray:last-child{border-right:none}.mat-header-row{border-color:#dddd}.highlighted{background-color:#fff!important}.modal-dialog{max-width:500px}`]
})
export class PipeRingsManagmentComponent implements OnInit {
  @ViewChild('fileUploadInput') fileInput;
  @Output() onShowViewer: EventEmitter<ShowViewerArgs> = new EventEmitter();

  public pipeRingData: any;
  public editedPipeRing = new PipeRingModel();
  public editedPipeRingVariant = new PipeRingVariantModel();
  public showPicture = false;
  public canOpenGraphicalTool = false;
  private stpConvertTaskId: string;
  public isStpVisible = false;
  public isPngVisible = false;
  public currentVariantTabId = '';
  public currentVariantTab = 0;
  public pictureData: string;
  public formGroup: FormGroup;
  public variantFormGroup: FormGroup;
  private duplicateMode = false;
  public choosenDesignBase: string;
  public piperingGroupsData: PiperingGroupModel[] = [];
  public corrosionProtectionData: CorosiveProtectionModel[] = [];
  public variantsList: PipeRingVariantModel[] = [];
  public designBasesArray: DesignBaseModel[] = [];
  public piperingFamiliesArray: any[] = [];

  constructor(private mainPageService: MainPageService, private zone: NgZone) {
    // this.graphicalRepresentationsArray = this.mainPageService.getPipeRingGraphicalRepresentationsArray();
    mainPageService.loadAllPiperingFamilies().subscribe((res) => {
      this.piperingFamiliesArray = res;
    });
   }

  public ngOnInit(): void {
    this.loadData();
    this.createForm();
    this.createVariantForm();
  }

  loadData(): void {
    this.mainPageService.loadAllPiperingGroups().subscribe((response) => {
      this.piperingGroupsData = response;
    });
    this.mainPageService.loadAllCorosionProtections().subscribe((response) => {
      this.corrosionProtectionData = response;
    });
    this.mainPageService.loadAllDesignBases().subscribe((response) => {
      this.designBasesArray = response;
      this.choosenDesignBase = this.designBasesArray[0]._id;
    });
  }

  loadPiperingVariants() {
    this.mainPageService.loadAllPiperingVariants(this.pipeRingData._id).subscribe((response) => {
      this.variantsList = response;
      if (this.variantsList.length > 0) {
        Object.assign(this.editedPipeRingVariant, this.variantsList[this.currentVariantTab]);
      }
      if (this.variantsList.length > 0) {
        this.currentVariantTabId = this.variantsList[this.currentVariantTab]._id;
      }
    });
  }

  showPipeRing(sender) {
    this.currentVariantTab = 0;
    this.currentVariantTabId = '';
    this.pipeRingData = sender;
    this.editedPipeRing = {
      ...this.pipeRingData
    };
    this.setFilesData(sender);
    this.canOpenGraphicalTool = sender.isProtoConverted === true;
    this.loadPiperingVariants();
  }

  upload(): void {
    this.readThis(this.fileInput.nativeElement.files[0]);
  }

  readThis(inputFile: any): void {
    const file: File = inputFile;
    const myReader: FileReader = new FileReader();
    const scope = this;
    myReader.onloadend = function () {
      if (file.name.includes('.stp') || file.name.includes('.step')) {
        scope.isStpVisible = true;
        scope.sendSTPFile(myReader.result, scope.pipeRingData._id);
      } else {
        scope.zone.run(() => scope.pictureData = myReader.result);
        scope.isPngVisible = true;
        scope.sendPictureFile(myReader.result, scope.pipeRingData._id);
      }
    };
    myReader.readAsDataURL(file);
  }

  checkIfStpIsConverted(): void {
    const self = this;
    setTimeout(() => {
      self.mainPageService.checkTaskStatus(self.stpConvertTaskId)
        .subscribe((resp) => {
          if (resp.isFinished === true) {
            self.zone.run(() => self.canOpenGraphicalTool = resp.result);
            //self.canOpenGraphicalTool = resp.result;
          } else {
            self.checkIfStpIsConverted();
          }
        });
    }, 2000);
  }
  sendSTPFile(file, id): void {
    this.canOpenGraphicalTool = false;
    this.mainPageService.sentSTPFileForPipeRings(file, id)
      .subscribe((response) => {
        this.pipeRingData.stepFile = response.fileId;
        this.stpConvertTaskId = response.id;
        console.log(response);
        this.checkIfStpIsConverted();
      },
        (error: any) => {
          console.log(error);
        }
      );
  }
  sendPictureFile(picture, id): void {
    this.mainPageService.sendPicture(picture, id)
      .subscribe((response) => {
        this.pipeRingData.picture = response.fileId;
      },
        (error: any) => {
          console.log(error);
        }
      );
  }

  openGraphicalTool(): void {
    this.onShowViewer.emit(new ShowViewerArgs(true, this.pipeRingData._id, 'PIPE_RING', null));
  }

  openVariantGraphicalTool(variantId): void {
    this.onShowViewer.emit(new ShowViewerArgs(true, this.pipeRingData._id, 'PIPE_RING', variantId));
  }

  changeVariantTab(id) {
    this.currentVariantTabId = id;
    for (let i = 0; i < this.variantsList.length; i++) {
      if (this.variantsList[i]._id === this.currentVariantTabId) {
        this.currentVariantTab = i;
        Object.assign(this.editedPipeRingVariant, this.variantsList[this.currentVariantTab]);
      }
    }
  }

  save(): void {
    Object.assign(this.pipeRingData, this.editedPipeRing);
    // this.mainPageService.mysubject.next(this.pipeRingData._id);
    
    this.mainPageService.updatePiperingInDb(JSON.stringify(this.pipeRingData)).subscribe(() => { });
  }

  deletePicture() {
    this.pictureData = '';
    this.isPngVisible = false;
    this.mainPageService.deleteFile(this.pipeRingData.picture).subscribe(() => {
    },
      () => {
      }
    );
    this.pipeRingData.picture = null;
  }

  deleteStepFile() {
    this.isStpVisible = false;
    this.mainPageService.deleteFile(this.pipeRingData.stepFile).subscribe(() => {
    },
      () => {
      }
    );
    this.pipeRingData.stepFile = null;
  }

  setFilesData(pipering) {
    if (pipering.picture !== undefined && pipering.picture !== null && pipering.picture !== "") {
      this.isPngVisible = true;
      this.mainPageService.getPicture(pipering.picture).subscribe((res) => {
        this.pictureData = res.src;
      },
        (error: any) => {
          console.log(error);
        }
      );
    } else {
      this.pictureData = '';
      this.isPngVisible = false;
    }

    if (pipering.stepFile !== undefined && pipering.stepFile !== null && pipering.stepFile !== "") {
      this.isStpVisible = true;
    } else {
      this.isStpVisible = false;
    }
  }

  deletePipeRing() {
    this.mainPageService.removePipering(this.pipeRingData._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePiperingSubject.next(this.pipeRingData._id);
    this.pipeRingData = undefined;
  }

  public prepareVariantCreate() {
    this.editedPipeRingVariant = new PipeRingVariantModel();
    this.createVariantForm();
  }

  private createVariantForm() {
    this.variantFormGroup = new FormGroup({
      name: new FormControl(this.editedPipeRingVariant.name, Validators.required),
      description: new FormControl(this.editedPipeRingVariant.description),
    });
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.editedPipeRing.name, Validators.required),
      articleId: new FormControl(this.editedPipeRing.articleId, Validators.required),
      piperingGroupId: new FormControl(this.editedPipeRing.piperingGroupId, Validators.required),
      corrosionProtectionId: new FormControl(this.editedPipeRing.corrosionProtectionId, Validators.required),
      piperingFamilyId: new FormControl(this.editedPipeRing.piperingFamilyId, Validators.required),
    });
  }

  saveNewVariant() {
    this.editedPipeRingVariant.piperingId = this.pipeRingData._id;
    this.sendVariantToDb(this.editedPipeRingVariant);
  }

  sendVariantToDb(variant) {
    this.mainPageService.addNewPiperingVariantIntoDb(JSON.stringify(variant))
      .subscribe((response) => {
        console.log(response);
        variant._id = response;
        this.variantsList.push(variant);
        if (this.variantsList.length === 1) {
          Object.assign(this.editedPipeRingVariant, this.variantsList[this.currentVariantTab]);
        }
        if (this.duplicateMode) {
          this.mainPageService.duplicateVariantData(
            this.variantsList[this.currentVariantTab]._id, this.variantsList[this.variantsList.length - 1]._id).subscribe(() => { });
          this.duplicateMode = false;
        }
        this.editedPipeRingVariant = new PipeRingVariantModel();
        if (this.currentVariantTabId === '') {
          this.currentVariantTabId = this.variantsList[0]._id;
        }
      },
        (error: any) => {
          console.log(error);
        }
      );
  }

  duplicateVariant() {
    this.duplicateMode = true;
    const newVariant = new PipeRingVariantModel();
    Object.assign(newVariant, this.variantsList[this.currentVariantTab]);
    newVariant.name = this.editedPipeRingVariant.name;
    this.sendVariantToDb(newVariant);
  }

  deleteVariant() {
    this.mainPageService.removePiperingVariant(this.variantsList[this.currentVariantTab]._id).subscribe(() => {
      const idToDelete = this.currentVariantTabId;
      if (this.currentVariantTab === (this.variantsList.length - 1) && this.currentVariantTab !== 0) {
        this.currentVariantTab -= 1;
        this.currentVariantTabId = this.variantsList[this.currentVariantTab]._id;
      }
      else if (this.currentVariantTab === 0 && this.variantsList.length === 1) {
        this.currentVariantTabId = '';
        this.currentVariantTab = 0;
      }
      else {
        this.currentVariantTabId = this.variantsList[this.currentVariantTab + 1]._id;
      }
      this.variantsList = this.variantsList.filter(variant => variant._id !== idToDelete);
      Object.assign(this.editedPipeRingVariant, this.variantsList[this.currentVariantTab]);
    }, () => { });
  }

  updateVariant() {
    Object.assign(this.variantsList[this.currentVariantTab], this.editedPipeRingVariant);
    this.mainPageService.updatePiperingVariantInDb(JSON.stringify(this.variantsList[this.currentVariantTab])).subscribe(() => { });
  }

  prepareVariantEdit() {
    Object.assign(this.editedPipeRingVariant, this.variantsList[this.currentVariantTab]);
  }

}
